module.exports = __webpack_public_path__ + "img/anaqueles-aguas.f66eca91.png";